import { render, staticRenderFns } from "./UnicodeEscapeList.vue?vue&type=template&id=f1c12626"
import script from "./UnicodeEscapeList.vue?vue&type=script&lang=js"
export * from "./UnicodeEscapeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports